import { useMemo } from 'react';
import type { StreamProduct } from '@igus/iglidur-free-form-hub-interfaces';

export const useMaterials = (products: StreamProduct[] | null) => {
  const extractedMaterials = useMemo(() => {
    if (!products || !products.length) {
      return [];
    }
    return products
      .map(product => product.material)
      .sort((materialA, materialB) => {
        return materialA.name > materialB.name ? 1 : -1;
      });
  }, [products]);

  const extractedMaterialNames = useMemo(() => {
    const materialNames = extractedMaterials.map(material => material.name);
    return [...new Set(materialNames)];
  }, [extractedMaterials]);

  const extractedProcedures = useMemo(() => {
    const procedures = extractedMaterials.map(material => material.procedure);

    return [...new Set(procedures)];
  }, [extractedMaterials]);

  return {
    materials: extractedMaterials,
    procedure: extractedProcedures,
    materialNames: extractedMaterialNames,
  };
};
